/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
};

export type AllInsightsType = {
  __typename?: 'AllInsightsType';
  advertiserDistribution: Maybe<Array<InsightsDistributionByAdvertiser>>;
  brandUnsafeRate: Scalars['Float'];
  topFlaggedUnsafeTopic: Scalars['String'];
  topSensitiveTopics: Maybe<Array<TopSensitiveTopicsType>>;
  topTopics: Maybe<Array<TopTopicsType>>;
  unsafeImpressions: Scalars['Int'];
};

export enum BrandChoicesEnum {
  AppleTv = 'Apple_TV',
  Bayer = 'Bayer',
  Demo = 'Demo'
}

export enum BreakdownTypeEnum {
  Combined = 'combined',
  Iab = 'iab',
  Keyword = 'keyword'
}

export type CampaignDataType = {
  __typename?: 'CampaignDataType';
  campaignId: Scalars['String'];
  clicks: Scalars['Int'];
  cpa: Scalars['Float'];
  cpc: Scalars['Float'];
  cpm: Scalars['Float'];
  cpv: Scalars['Float'];
  ctr: Scalars['Float'];
  date: Scalars['Date'];
  impressions: Scalars['Int'];
  mediaCost: Scalars['Float'];
  vcr: Scalars['Float'];
  viewability: Scalars['Float'];
};

export type CategorisationResultsType = {
  __typename?: 'CategorisationResultsType';
  cat_brandsafety: Maybe<Array<Scalars['String']>>;
  illuma_emotion: Maybe<Array<Scalars['String']>>;
  illuma_ents_CARDINAL: Maybe<Array<Scalars['String']>>;
  illuma_ents_DATE: Maybe<Array<Scalars['String']>>;
  illuma_ents_EVENT: Maybe<Array<Scalars['String']>>;
  illuma_ents_FAC: Maybe<Array<Scalars['String']>>;
  illuma_ents_GPE: Maybe<Array<Scalars['String']>>;
  illuma_ents_LANGUAGE: Maybe<Array<Scalars['String']>>;
  illuma_ents_LAW: Maybe<Array<Scalars['String']>>;
  illuma_ents_LOC: Maybe<Array<Scalars['String']>>;
  illuma_ents_MONEY: Maybe<Array<Scalars['String']>>;
  illuma_ents_NORP: Maybe<Array<Scalars['String']>>;
  illuma_ents_ORDINAL: Maybe<Array<Scalars['String']>>;
  illuma_ents_ORG: Maybe<Array<Scalars['String']>>;
  illuma_ents_PERCENT: Maybe<Array<Scalars['String']>>;
  illuma_ents_PERSON: Maybe<Array<Scalars['String']>>;
  illuma_ents_PRODUCT: Maybe<Array<Scalars['String']>>;
  illuma_ents_QUANTITY: Maybe<Array<Scalars['String']>>;
  illuma_ents_TIME: Maybe<Array<Scalars['String']>>;
  illuma_ents_WORK_OF_ART: Maybe<Array<Scalars['String']>>;
  illuma_sent: Maybe<Array<Scalars['String']>>;
  precision_iab_v3: Maybe<Array<Scalars['String']>>;
};

export type InsightDistributionByDate = {
  __typename?: 'InsightDistributionByDate';
  aggregationDate: Scalars['Date'];
  allImpressions: Scalars['Int'];
  brandUnsafeRate: Scalars['Float'];
};

export type InsightsDistributionByAdvertiser = {
  __typename?: 'InsightsDistributionByAdvertiser';
  advertiserId: Scalars['String'];
  advertiserName: Scalars['String'];
  aggregationDate: Scalars['Date'];
  brandUnsafeRate: Scalars['Float'];
  totalImpressions: Scalars['Int'];
};

export enum LineTypeChoicesEnum {
  Adgroup = 'Adgroup',
  Campaign = 'Campaign',
  LineItem = 'LineItem',
  Order = 'Order',
  Split = 'Split'
}

export type PredictedUrlsType = {
  __typename?: 'PredictedUrlsType';
  predictedFrom: Scalars['String'];
  urls: Array<Scalars['String']>;
};

export type PublisherDomainType = {
  __typename?: 'PublisherDomainType';
  domain: Scalars['String'];
  id: Scalars['Int'];
  publisher: Scalars['String'];
};

export enum PublisherEnum {
  Arena = 'ARENA',
  Demo = 'DEMO',
  IrishTimes = 'IRISH_TIMES',
  Nca = 'NCA',
  NewsUk = 'NEWS_UK'
}

export type Query = {
  __typename?: 'Query';
  brandSafetyInsights: AllInsightsType;
  brandSafetyInsightsDistributionByDate: TotalInsightDistributionByDate;
  getTacticIds: TacticIdsType;
  predictedUrlsList: PredictedUrlsType;
  publisherDomains: Array<PublisherDomainType>;
  reportStoreCampaign: ReportStoreCampaignType;
  urlClassification: UrlType;
  urlList: UrlListPaginatedType;
};


export type QueryBrandSafetyInsightsArgs = {
  adGroupIds: Maybe<Array<Scalars['String']>>;
  advertiserIds: Maybe<Array<Scalars['String']>>;
  brand: BrandChoicesEnum;
  breakdownType: BreakdownTypeEnum;
  campaignIds: Maybe<Array<Scalars['String']>>;
  endDate: Scalars['Date'];
  pageTypes: Maybe<Array<Scalars['String']>>;
  startDate: Scalars['Date'];
};


export type QueryBrandSafetyInsightsDistributionByDateArgs = {
  adGroupIds: Maybe<Array<Scalars['String']>>;
  advertiserIds: Maybe<Array<Scalars['String']>>;
  brand: BrandChoicesEnum;
  breakdownType: BreakdownTypeEnum;
  campaignIds: Maybe<Array<Scalars['String']>>;
  endDate: Scalars['Date'];
  pageTypes: Maybe<Array<Scalars['String']>>;
  startDate: Scalars['Date'];
};


export type QueryGetTacticIdsArgs = {
  adGroupIds: Maybe<Array<Scalars['String']>>;
  advertiserIds: Maybe<Array<Scalars['String']>>;
  brand: BrandChoicesEnum;
  breakdownType: BreakdownTypeEnum;
  campaignIds: Maybe<Array<Scalars['String']>>;
  endDate: Scalars['Date'];
  idType: TacticIdTypeEnum;
  pageTypes: Maybe<Array<Scalars['String']>>;
  startDate: Scalars['Date'];
};


export type QueryPredictedUrlsListArgs = {
  matchThreshold?: Scalars['Float'];
  publisher: PublisherEnum;
  url: Scalars['String'];
};


export type QueryPublisherDomainsArgs = {
  isStaff?: Maybe<Scalars['Boolean']>;
  publisher?: Maybe<PublisherEnum>;
};


export type QueryReportStoreCampaignArgs = {
  costColumn: Scalars['String'];
  dsp: Scalars['String'];
  endDate: Scalars['Date'];
  lineItemIds: Array<Scalars['String']>;
  lineType: LineTypeChoicesEnum;
  startDate: Scalars['Date'];
};


export type QueryUrlClassificationArgs = {
  publisher: PublisherEnum;
  url: Scalars['String'];
};


export type QueryUrlListArgs = {
  category?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  first: Scalars['Int'];
  offset: Scalars['Int'];
  orderByDate?: Maybe<Scalars['Boolean']>;
  publisher: PublisherEnum;
  range?: Maybe<RangeEnum>;
  search?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};

export enum RangeEnum {
  All = 'ALL',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS'
}

export type ReportStoreCampaignType = {
  __typename?: 'ReportStoreCampaignType';
  campaign_data: Maybe<Array<CampaignDataType>>;
};

export enum TacticIdTypeEnum {
  AdGroupId = 'ad_group_id',
  CampaignId = 'campaign_id'
}

export type TacticIdsType = {
  __typename?: 'TacticIdsType';
  ids: Array<Scalars['String']>;
};

export type TopSensitiveTopicsType = {
  __typename?: 'TopSensitiveTopicsType';
  aggregationDate: Scalars['Date'];
  sensitiveTopic: Scalars['String'];
  totalUnsafeImpressions: Scalars['Int'];
  unsafeImpressionShare: Scalars['Float'];
};

export type TopTopicsType = {
  __typename?: 'TopTopicsType';
  aggregationDate: Scalars['Date'];
  impressionShare: Scalars['Float'];
  topic: Scalars['String'];
};

export type TotalInsightDistributionByDate = {
  __typename?: 'TotalInsightDistributionByDate';
  insightDistributionByDate: Maybe<Array<InsightDistributionByDate>>;
};

export type UrlListPaginatedType = {
  __typename?: 'UrlListPaginatedType';
  hasNextPage: Scalars['Boolean'];
  urlList: Array<UrlListType>;
};

export type UrlListType = {
  __typename?: 'UrlListType';
  id: Scalars['Int'];
  insertionTime: Scalars['DateTime'];
  lastUpdateTime: Maybe<Scalars['DateTime']>;
  pageUrl: Scalars['String'];
};

export type UrlType = {
  __typename?: 'UrlType';
  id: Scalars['Int'];
  insertionTime: Scalars['String'];
  lastUpdateTime: Maybe<Scalars['String']>;
  pageUrl: Scalars['String'];
  results: CategorisationResultsType;
};

export type UrlClassificationQueryVariables = Exact<{
  url: Scalars['String'];
  publisher: PublisherEnum;
}>;


export type UrlClassificationQuery = { __typename?: 'Query', urlClassification: { __typename?: 'UrlType', id: number, pageUrl: string, lastUpdateTime: string | null, results: { __typename?: 'CategorisationResultsType', precision_iab_v3: Array<string> | null, cat_brandsafety: Array<string> | null, illuma_sent: Array<string> | null, illuma_emotion: Array<string> | null, illuma_ents_FAC: Array<string> | null, illuma_ents_ORG: Array<string> | null, illuma_ents_GPE: Array<string> | null, illuma_ents_LOC: Array<string> | null, illuma_ents_PRODUCT: Array<string> | null, illuma_ents_NORP: Array<string> | null, illuma_ents_DATE: Array<string> | null, illuma_ents_EVENT: Array<string> | null, illuma_ents_PERSON: Array<string> | null, illuma_ents_LAW: Array<string> | null, illuma_ents_LANGUAGE: Array<string> | null, illuma_ents_MONEY: Array<string> | null, illuma_ents_WORK_OF_ART: Array<string> | null } } };

export type UrlListQueryVariables = Exact<{
  publisher: PublisherEnum;
  first: Scalars['Int'];
  offset: Scalars['Int'];
  search: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  range: Maybe<RangeEnum>;
  startDate: Maybe<Scalars['Date']>;
  endDate: Maybe<Scalars['Date']>;
}>;


export type UrlListQuery = { __typename?: 'Query', urlList: { __typename?: 'UrlListPaginatedType', hasNextPage: boolean, urlList: Array<{ __typename?: 'UrlListType', id: number, pageUrl: string, insertionTime: any, lastUpdateTime: any | null }> } };

export type ReportStoreCampaignQueryVariables = Exact<{
  dsp: Scalars['String'];
  lineItemIds: Array<Scalars['String']> | Scalars['String'];
  lineType: LineTypeChoicesEnum;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  costColumn: Scalars['String'];
}>;


export type ReportStoreCampaignQuery = { __typename?: 'Query', reportStoreCampaign: { __typename?: 'ReportStoreCampaignType', campaign_data: Array<{ __typename?: 'CampaignDataType', date: any, mediaCost: number, campaignId: string, impressions: number, clicks: number, vcr: number, cpv: number, cpa: number, cpc: number, ctr: number, cpm: number, viewability: number }> | null } };

export type PredictedUrlsListQueryVariables = Exact<{
  publisher: PublisherEnum;
  url: Scalars['String'];
  matchThreshold: Scalars['Float'];
}>;


export type PredictedUrlsListQuery = { __typename?: 'Query', predictedUrlsList: { __typename?: 'PredictedUrlsType', predictedFrom: string, urls: Array<string> } };

export type PublisherDomainsQueryVariables = Exact<{
  isStaff: Maybe<Scalars['Boolean']>;
  publisher: Maybe<PublisherEnum>;
}>;


export type PublisherDomainsQuery = { __typename?: 'Query', publisherDomains: Array<{ __typename?: 'PublisherDomainType', id: number, domain: string, publisher: string }> };

export type BrandSafetyInsightsQueryVariables = Exact<{
  breakdownType: BreakdownTypeEnum;
  brand: BrandChoicesEnum;
  pageTypes: Maybe<Array<Scalars['String']> | Scalars['String']>;
  advertiserIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  campaignIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  adGroupIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type BrandSafetyInsightsQuery = { __typename?: 'Query', brandSafetyInsights: { __typename?: 'AllInsightsType', brandUnsafeRate: number, unsafeImpressions: number, topFlaggedUnsafeTopic: string, advertiserDistribution: Array<{ __typename?: 'InsightsDistributionByAdvertiser', advertiserId: string, totalImpressions: number, brandUnsafeRate: number }> | null, topSensitiveTopics: Array<{ __typename?: 'TopSensitiveTopicsType', sensitiveTopic: string, totalUnsafeImpressions: number, unsafeImpressionShare: number }> | null, topTopics: Array<{ __typename?: 'TopTopicsType', topic: string, impressionShare: number }> | null } };

export type BrandSafetyInsightsDistributionByDateQueryVariables = Exact<{
  breakdownType: BreakdownTypeEnum;
  brand: BrandChoicesEnum;
  pageTypes: Maybe<Array<Scalars['String']> | Scalars['String']>;
  advertiserIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  campaignIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  adGroupIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type BrandSafetyInsightsDistributionByDateQuery = { __typename?: 'Query', brandSafetyInsightsDistributionByDate: { __typename?: 'TotalInsightDistributionByDate', insightDistributionByDate: Array<{ __typename?: 'InsightDistributionByDate', aggregationDate: any, allImpressions: number, brandUnsafeRate: number }> | null } };

export type GetTacticIdsQueryVariables = Exact<{
  breakdownType: BreakdownTypeEnum;
  brand: BrandChoicesEnum;
  pageTypes: Maybe<Array<Scalars['String']> | Scalars['String']>;
  advertiserIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  campaignIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  adGroupIds: Maybe<Array<Scalars['String']> | Scalars['String']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  idType: TacticIdTypeEnum;
}>;


export type GetTacticIdsQuery = { __typename?: 'Query', getTacticIds: { __typename?: 'TacticIdsType', ids: Array<string> } };


export const UrlClassificationDocument = gql`
    query UrlClassification($url: String!, $publisher: PublisherEnum!) {
  urlClassification(url: $url, publisher: $publisher) {
    id
    pageUrl
    lastUpdateTime
    results {
      precision_iab_v3
      cat_brandsafety
      illuma_sent
      illuma_emotion
      illuma_ents_FAC
      illuma_ents_ORG
      illuma_ents_GPE
      illuma_ents_LOC
      illuma_ents_PRODUCT
      illuma_ents_NORP
      illuma_ents_DATE
      illuma_ents_EVENT
      illuma_ents_PERSON
      illuma_ents_LAW
      illuma_ents_LANGUAGE
      illuma_ents_MONEY
      illuma_ents_WORK_OF_ART
    }
  }
}
    `;

/**
 * __useUrlClassificationQuery__
 *
 * To run a query within a React component, call `useUrlClassificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlClassificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlClassificationQuery({
 *   variables: {
 *      url: // value for 'url'
 *      publisher: // value for 'publisher'
 *   },
 * });
 */
export function useUrlClassificationQuery(baseOptions: Apollo.QueryHookOptions<UrlClassificationQuery, UrlClassificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UrlClassificationQuery, UrlClassificationQueryVariables>(UrlClassificationDocument, options);
      }
export function useUrlClassificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UrlClassificationQuery, UrlClassificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UrlClassificationQuery, UrlClassificationQueryVariables>(UrlClassificationDocument, options);
        }
export type UrlClassificationQueryHookResult = ReturnType<typeof useUrlClassificationQuery>;
export type UrlClassificationLazyQueryHookResult = ReturnType<typeof useUrlClassificationLazyQuery>;
export type UrlClassificationQueryResult = Apollo.QueryResult<UrlClassificationQuery, UrlClassificationQueryVariables>;
export const UrlListDocument = gql`
    query UrlList($publisher: PublisherEnum!, $first: Int!, $offset: Int!, $search: String, $category: String, $range: RangeEnum, $startDate: Date, $endDate: Date) {
  urlList(
    publisher: $publisher
    first: $first
    offset: $offset
    search: $search
    category: $category
    range: $range
    startDate: $startDate
    endDate: $endDate
  ) {
    hasNextPage
    urlList {
      id
      pageUrl
      insertionTime
      lastUpdateTime
    }
  }
}
    `;

/**
 * __useUrlListQuery__
 *
 * To run a query within a React component, call `useUrlListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlListQuery({
 *   variables: {
 *      publisher: // value for 'publisher'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      range: // value for 'range'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUrlListQuery(baseOptions: Apollo.QueryHookOptions<UrlListQuery, UrlListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UrlListQuery, UrlListQueryVariables>(UrlListDocument, options);
      }
export function useUrlListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UrlListQuery, UrlListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UrlListQuery, UrlListQueryVariables>(UrlListDocument, options);
        }
export type UrlListQueryHookResult = ReturnType<typeof useUrlListQuery>;
export type UrlListLazyQueryHookResult = ReturnType<typeof useUrlListLazyQuery>;
export type UrlListQueryResult = Apollo.QueryResult<UrlListQuery, UrlListQueryVariables>;
export const ReportStoreCampaignDocument = gql`
    query ReportStoreCampaign($dsp: String!, $lineItemIds: [String!]!, $lineType: LineTypeChoicesEnum!, $startDate: Date!, $endDate: Date!, $costColumn: String!) {
  reportStoreCampaign(
    dsp: $dsp
    lineItemIds: $lineItemIds
    lineType: $lineType
    startDate: $startDate
    endDate: $endDate
    costColumn: $costColumn
  ) {
    campaign_data {
      date
      mediaCost
      campaignId
      impressions
      clicks
      vcr
      cpv
      cpa
      cpc
      ctr
      cpm
      viewability
    }
  }
}
    `;

/**
 * __useReportStoreCampaignQuery__
 *
 * To run a query within a React component, call `useReportStoreCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportStoreCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportStoreCampaignQuery({
 *   variables: {
 *      dsp: // value for 'dsp'
 *      lineItemIds: // value for 'lineItemIds'
 *      lineType: // value for 'lineType'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      costColumn: // value for 'costColumn'
 *   },
 * });
 */
export function useReportStoreCampaignQuery(baseOptions: Apollo.QueryHookOptions<ReportStoreCampaignQuery, ReportStoreCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportStoreCampaignQuery, ReportStoreCampaignQueryVariables>(ReportStoreCampaignDocument, options);
      }
export function useReportStoreCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportStoreCampaignQuery, ReportStoreCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportStoreCampaignQuery, ReportStoreCampaignQueryVariables>(ReportStoreCampaignDocument, options);
        }
export type ReportStoreCampaignQueryHookResult = ReturnType<typeof useReportStoreCampaignQuery>;
export type ReportStoreCampaignLazyQueryHookResult = ReturnType<typeof useReportStoreCampaignLazyQuery>;
export type ReportStoreCampaignQueryResult = Apollo.QueryResult<ReportStoreCampaignQuery, ReportStoreCampaignQueryVariables>;
export const PredictedUrlsListDocument = gql`
    query PredictedUrlsList($publisher: PublisherEnum!, $url: String!, $matchThreshold: Float!) {
  predictedUrlsList(
    publisher: $publisher
    url: $url
    matchThreshold: $matchThreshold
  ) {
    predictedFrom
    urls
  }
}
    `;

/**
 * __usePredictedUrlsListQuery__
 *
 * To run a query within a React component, call `usePredictedUrlsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictedUrlsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictedUrlsListQuery({
 *   variables: {
 *      publisher: // value for 'publisher'
 *      url: // value for 'url'
 *      matchThreshold: // value for 'matchThreshold'
 *   },
 * });
 */
export function usePredictedUrlsListQuery(baseOptions: Apollo.QueryHookOptions<PredictedUrlsListQuery, PredictedUrlsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictedUrlsListQuery, PredictedUrlsListQueryVariables>(PredictedUrlsListDocument, options);
      }
export function usePredictedUrlsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictedUrlsListQuery, PredictedUrlsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictedUrlsListQuery, PredictedUrlsListQueryVariables>(PredictedUrlsListDocument, options);
        }
export type PredictedUrlsListQueryHookResult = ReturnType<typeof usePredictedUrlsListQuery>;
export type PredictedUrlsListLazyQueryHookResult = ReturnType<typeof usePredictedUrlsListLazyQuery>;
export type PredictedUrlsListQueryResult = Apollo.QueryResult<PredictedUrlsListQuery, PredictedUrlsListQueryVariables>;
export const PublisherDomainsDocument = gql`
    query PublisherDomains($isStaff: Boolean, $publisher: PublisherEnum) {
  publisherDomains(isStaff: $isStaff, publisher: $publisher) {
    id
    domain
    publisher
  }
}
    `;

/**
 * __usePublisherDomainsQuery__
 *
 * To run a query within a React component, call `usePublisherDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherDomainsQuery({
 *   variables: {
 *      isStaff: // value for 'isStaff'
 *      publisher: // value for 'publisher'
 *   },
 * });
 */
export function usePublisherDomainsQuery(baseOptions?: Apollo.QueryHookOptions<PublisherDomainsQuery, PublisherDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublisherDomainsQuery, PublisherDomainsQueryVariables>(PublisherDomainsDocument, options);
      }
export function usePublisherDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublisherDomainsQuery, PublisherDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublisherDomainsQuery, PublisherDomainsQueryVariables>(PublisherDomainsDocument, options);
        }
export type PublisherDomainsQueryHookResult = ReturnType<typeof usePublisherDomainsQuery>;
export type PublisherDomainsLazyQueryHookResult = ReturnType<typeof usePublisherDomainsLazyQuery>;
export type PublisherDomainsQueryResult = Apollo.QueryResult<PublisherDomainsQuery, PublisherDomainsQueryVariables>;
export const BrandSafetyInsightsDocument = gql`
    query BrandSafetyInsights($breakdownType: BreakdownTypeEnum!, $brand: BrandChoicesEnum!, $pageTypes: [String!], $advertiserIds: [String!], $campaignIds: [String!], $adGroupIds: [String!], $startDate: Date!, $endDate: Date!) {
  brandSafetyInsights(
    breakdownType: $breakdownType
    brand: $brand
    pageTypes: $pageTypes
    advertiserIds: $advertiserIds
    campaignIds: $campaignIds
    adGroupIds: $adGroupIds
    startDate: $startDate
    endDate: $endDate
  ) {
    brandUnsafeRate
    unsafeImpressions
    advertiserDistribution {
      advertiserId
      totalImpressions
      brandUnsafeRate
    }
    topFlaggedUnsafeTopic
    topSensitiveTopics {
      sensitiveTopic
      totalUnsafeImpressions
      unsafeImpressionShare
    }
    topTopics {
      topic
      impressionShare
    }
  }
}
    `;

/**
 * __useBrandSafetyInsightsQuery__
 *
 * To run a query within a React component, call `useBrandSafetyInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSafetyInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSafetyInsightsQuery({
 *   variables: {
 *      breakdownType: // value for 'breakdownType'
 *      brand: // value for 'brand'
 *      pageTypes: // value for 'pageTypes'
 *      advertiserIds: // value for 'advertiserIds'
 *      campaignIds: // value for 'campaignIds'
 *      adGroupIds: // value for 'adGroupIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useBrandSafetyInsightsQuery(baseOptions: Apollo.QueryHookOptions<BrandSafetyInsightsQuery, BrandSafetyInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSafetyInsightsQuery, BrandSafetyInsightsQueryVariables>(BrandSafetyInsightsDocument, options);
      }
export function useBrandSafetyInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSafetyInsightsQuery, BrandSafetyInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSafetyInsightsQuery, BrandSafetyInsightsQueryVariables>(BrandSafetyInsightsDocument, options);
        }
export type BrandSafetyInsightsQueryHookResult = ReturnType<typeof useBrandSafetyInsightsQuery>;
export type BrandSafetyInsightsLazyQueryHookResult = ReturnType<typeof useBrandSafetyInsightsLazyQuery>;
export type BrandSafetyInsightsQueryResult = Apollo.QueryResult<BrandSafetyInsightsQuery, BrandSafetyInsightsQueryVariables>;
export const BrandSafetyInsightsDistributionByDateDocument = gql`
    query BrandSafetyInsightsDistributionByDate($breakdownType: BreakdownTypeEnum!, $brand: BrandChoicesEnum!, $pageTypes: [String!], $advertiserIds: [String!], $campaignIds: [String!], $adGroupIds: [String!], $startDate: Date!, $endDate: Date!) {
  brandSafetyInsightsDistributionByDate(
    breakdownType: $breakdownType
    brand: $brand
    pageTypes: $pageTypes
    advertiserIds: $advertiserIds
    campaignIds: $campaignIds
    adGroupIds: $adGroupIds
    startDate: $startDate
    endDate: $endDate
  ) {
    insightDistributionByDate {
      aggregationDate
      allImpressions
      brandUnsafeRate
    }
  }
}
    `;

/**
 * __useBrandSafetyInsightsDistributionByDateQuery__
 *
 * To run a query within a React component, call `useBrandSafetyInsightsDistributionByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSafetyInsightsDistributionByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSafetyInsightsDistributionByDateQuery({
 *   variables: {
 *      breakdownType: // value for 'breakdownType'
 *      brand: // value for 'brand'
 *      pageTypes: // value for 'pageTypes'
 *      advertiserIds: // value for 'advertiserIds'
 *      campaignIds: // value for 'campaignIds'
 *      adGroupIds: // value for 'adGroupIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useBrandSafetyInsightsDistributionByDateQuery(baseOptions: Apollo.QueryHookOptions<BrandSafetyInsightsDistributionByDateQuery, BrandSafetyInsightsDistributionByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSafetyInsightsDistributionByDateQuery, BrandSafetyInsightsDistributionByDateQueryVariables>(BrandSafetyInsightsDistributionByDateDocument, options);
      }
export function useBrandSafetyInsightsDistributionByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSafetyInsightsDistributionByDateQuery, BrandSafetyInsightsDistributionByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSafetyInsightsDistributionByDateQuery, BrandSafetyInsightsDistributionByDateQueryVariables>(BrandSafetyInsightsDistributionByDateDocument, options);
        }
export type BrandSafetyInsightsDistributionByDateQueryHookResult = ReturnType<typeof useBrandSafetyInsightsDistributionByDateQuery>;
export type BrandSafetyInsightsDistributionByDateLazyQueryHookResult = ReturnType<typeof useBrandSafetyInsightsDistributionByDateLazyQuery>;
export type BrandSafetyInsightsDistributionByDateQueryResult = Apollo.QueryResult<BrandSafetyInsightsDistributionByDateQuery, BrandSafetyInsightsDistributionByDateQueryVariables>;
export const GetTacticIdsDocument = gql`
    query GetTacticIds($breakdownType: BreakdownTypeEnum!, $brand: BrandChoicesEnum!, $pageTypes: [String!], $advertiserIds: [String!], $campaignIds: [String!], $adGroupIds: [String!], $startDate: Date!, $endDate: Date!, $idType: TacticIdTypeEnum!) {
  getTacticIds(
    breakdownType: $breakdownType
    brand: $brand
    pageTypes: $pageTypes
    advertiserIds: $advertiserIds
    campaignIds: $campaignIds
    adGroupIds: $adGroupIds
    startDate: $startDate
    endDate: $endDate
    idType: $idType
  ) {
    ids
  }
}
    `;

/**
 * __useGetTacticIdsQuery__
 *
 * To run a query within a React component, call `useGetTacticIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTacticIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTacticIdsQuery({
 *   variables: {
 *      breakdownType: // value for 'breakdownType'
 *      brand: // value for 'brand'
 *      pageTypes: // value for 'pageTypes'
 *      advertiserIds: // value for 'advertiserIds'
 *      campaignIds: // value for 'campaignIds'
 *      adGroupIds: // value for 'adGroupIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      idType: // value for 'idType'
 *   },
 * });
 */
export function useGetTacticIdsQuery(baseOptions: Apollo.QueryHookOptions<GetTacticIdsQuery, GetTacticIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTacticIdsQuery, GetTacticIdsQueryVariables>(GetTacticIdsDocument, options);
      }
export function useGetTacticIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTacticIdsQuery, GetTacticIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTacticIdsQuery, GetTacticIdsQueryVariables>(GetTacticIdsDocument, options);
        }
export type GetTacticIdsQueryHookResult = ReturnType<typeof useGetTacticIdsQuery>;
export type GetTacticIdsLazyQueryHookResult = ReturnType<typeof useGetTacticIdsLazyQuery>;
export type GetTacticIdsQueryResult = Apollo.QueryResult<GetTacticIdsQuery, GetTacticIdsQueryVariables>;